module.exports = __webpack_public_path__ + "static/img/address_m.74add0c.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/address_m.png
// module id = +wwR
// module chunks = 1